import { Fragment } from "react";
import { Button, message } from "antd";
import { deleteParticipantes } from "../../api/sorteo";

/**
 * DeleteRecord
 * @param {Object} record
 * @param {Function} closeModal
 */
function SortearDeleteParticipantes({ closeModal, fetchData }) {
  // ------ Elimina participantes ------
  const handleDelete = async () => {
    try {
      const response = await deleteParticipantes();
      message.success(response.message);
      closeModal();
      fetchData();
    } catch (err) {
      message.error(err.message);
    }
  };

  // ----- render -----
  return (
    <Fragment>
      <p className="mt-2 mb-6 text-base">
        ¿Estás seguro de limpiar los datos? tendrás que subir de nuevo el excel
      </p>
      <div className="flex justify-end gap-4">
        <Button type="danger" htmlType="submit" onClick={() => handleDelete()}>
          Sí, limpiar
        </Button>
        <Button type="default" onClick={() => closeModal()}>
          Cancelar
        </Button>
      </div>
    </Fragment>
  );
}
export default SortearDeleteParticipantes;
